export const ValidacaoClienteModais = {
  modalPeriodoTrial: 'modalPeriodoTrial',
  modalClienteBloqueado: 'modalClienteBloqueado',
  modalDesbloqueioSolicitado: 'modalDesbloqueioSolicitado',
};
